import React, { useState, useEffect } from 'react';
import { DefaultNodeConfig } from '../../../flowchart-node-panel';
import { FlowchartFormWrapper } from '../../form-wrapper';
import { InputFiled, ColorPicker, Position, InputNumberFiled, Size } from './fields';
import { PREFIX } from './constants';
const GroupComponent = props => {
    const { config, plugin = {} } = props;
    const { updateGroup } = plugin;
    const [groupConfig, setGroupConfig] = useState(Object.assign(Object.assign({}, DefaultNodeConfig), config));
    const onGroupConfigChange = (key, value) => {
        setGroupConfig(Object.assign(Object.assign({}, groupConfig), { [key]: value }));
        updateGroup({
            [key]: value,
        });
    };
    useEffect(() => {
        setGroupConfig(Object.assign(Object.assign({}, DefaultNodeConfig), config));
    }, [config]);
    return (React.createElement("div", { className: `${PREFIX}-panel-body` },
        React.createElement("div", { className: `${PREFIX}-panel-group` },
            React.createElement("h5", null, "\u5185\u5BB9"),
            React.createElement(InputFiled, { label: "\u6807\u9898", value: groupConfig.label, onChange: value => {
                    onGroupConfigChange('label', value);
                } })),
        React.createElement("div", { className: `${PREFIX}-panel-group` },
            React.createElement("h5", null, "\u6837\u5F0F"),
            React.createElement(Position, { x: groupConfig.x, y: groupConfig.y, onChange: (key, value) => {
                    onGroupConfigChange(key, value);
                } }),
            React.createElement(Size, { width: groupConfig.width, height: groupConfig.height, onChange: (key, value) => {
                    onGroupConfigChange(key, value);
                } }),
            React.createElement(ColorPicker, { label: "\u586B\u5145", value: groupConfig.fill, onChange: (value) => {
                    onGroupConfigChange('fill', value);
                } }),
            React.createElement(ColorPicker, { label: "\u8FB9\u6846", value: groupConfig.stroke, onChange: (value) => {
                    onGroupConfigChange('stroke', value);
                } }),
            React.createElement("div", { className: `${PREFIX}-node-text-style` },
                React.createElement(InputNumberFiled, { label: "\u5B57\u53F7", value: groupConfig.fontSize, width: 68, onChange: value => {
                        onGroupConfigChange('fontSize', value);
                    } }),
                React.createElement(ColorPicker, { value: groupConfig.fontFill, onChange: (value) => {
                        onGroupConfigChange('fontFill', value);
                    } })))));
};
export const GroupService = props => {
    return (React.createElement(FlowchartFormWrapper, Object.assign({}, props), (config, plugin) => React.createElement(GroupComponent, Object.assign({}, props, { plugin: plugin, config: config }))));
};
//# sourceMappingURL=group.js.map